import {amount, rateCalculate} from "../formatters/Numbers";
import {amountCalculate} from "../formatters/Numbers";

export function withoutComma(comma) {
    return (comma + '').replace(/,/g, '') * 1;
}

export function calculateAmount(price, titles) {
    if (price !== undefined || titles !== undefined) {
        let calculate = withoutComma(price) * withoutComma(titles);
        return calculate === 0 ? '' : amount(calculate);
    }
}

export function calculateRewardContainer(amountValue, price, rate, maturity) {
    return amountCalculate(getReward(amountValue, price, rate, maturity));

}

export function calculateRateContainer(reward, amountValue, price, maturity) {
    return rateCalculate(getRate(reward, amountValue, price, maturity));
}

function getRate(reward, amountValue, price, maturity) {
    if (amountValue !== undefined
        || price !== undefined
        || maturity !== undefined
        || reward !== undefined) {
        return withoutComma(reward) * 36000 / (withoutComma(amountValue) * withoutComma(price) * withoutComma(maturity));
    }
    return 0;
}

export function calculateReward(amountValue, price, rate, maturity) {
    let calculate = getReward(amountValue, price, rate, maturity);
    return calculate === 0 ? '' : amount(calculate);
}

export function getReward(amountValue, price, rate, maturity) {
    if (amountValue !== undefined
        || price !== undefined
        || rate !== undefined
        || maturity !== undefined) {
        return (withoutComma(amountValue) * withoutComma(price) * withoutComma(rate) * withoutComma(maturity)) / 36000;
    } else {
        return 0;
    }
}

export function getSuggestedInAccount(loanAmount, guaranteeAmount, discountPrice) {
    return Math.ceil((loanAmount - guaranteeAmount) / discountPrice);
}

/**
 * Cálculos Bilaterales
 * **/
export function getZeroOrNewTitles(newTitles) {
    if (newTitles === undefined || newTitles === '') {
        return 0;
    } else {
        return newTitles;
    }
}
